export default {
  dashboard: {
    title: '工作面板',
    today_orders: '今日订单',
    today_recharge: '今日充值',
    today_users: '今日用户',
    yesterday: '昨日',
    count: '数量',
    power: '电量',
    sum: '总额',
    new_users_count: '新增用户数',
    sign_in_users_count: '上线用户数',
    not_unavailable: '非下架',
    charge_station_count: '充电站',
    charger_count: '充电枪',
    order_trend_per_hour: '每小时订单趋势',
    order_trend_per_week: '每日订单趋势',
    to_do_list: '待办事项',
    station_overview: '站总概况',
    check_stations: '查看单个站',
    today: '今日',
    dc_station: '直流站',
    ac_station: '交流站',
    order_amount: '订单金额',
    order_powers: '订单电量',
    dc_charger: '直流枪',
    ac_charger: '交流枪',
    pending_invoices: '发票申请',
    pending_invoices_description: '未开票',
    withdraw_applications: '用户提现',
    withdraw_applications_description: '待审核、待转账',
    group_applications: '集团用户',
    group_applications_description: '待审核',
    total_uncompleted_work_orders_count: '未完成工单',
    my_uncompleted_work_orders_count: '我的未完成工单',
    work_orders_description: '未处理、处理中',
    comments: '评论/点评',
    comments_description: '待处理',
    group_balance_not_enough: '集团余额不足',
    group_balance_not_enough_description: '待处理',
    timed_effective_rate: '定时生效费率',
    rate_description: '待确认费率',
    increase: '上升',
    decrease: '下降',
    income_overview: '收入概况',
    income_overview_content: '上周服务费收入 <span class="color-green">{0}</span> 元，环比<span class="color-{1}">{2}%</span>',
    transaction_overview: '交易概况',
    transaction_overview_content: '上周场站充电量 <span class="color-green">{0}</span> 度，环比<span class="color-{1}">{2}%</span>',
    price_overview: '价格概况',
    price_overview_content: '上周每度电服务费为 <span class="color-green">{0}</span> 元，环比<span class="color-{1}">{2}%</span>',
    user_overview: '用户概况',
    user_overview_content: '电量主要来源大类是<span class="color-green">忠诚用户</span>，占场站整个充电量的 <span class="color-green">{0}%</span>',
    new_users_overview: '带来用户',
    new_users_overview_content:
      '上周场站充电的用户数，其中：<br/><span class="color-green">{0} {1}</span> 人（曝光用户数 <span class="color-green">{2}</span> 人，交易转化率 <span class="color-green">{3}%</span>）、<br/><span class="color-blue">互联互通 {4}</span> 人',
    equipment_overview: '设备概况',
    equipment_overview_content: '上周充电成功率 <span class="color-green">{0}%</span>'
  }
}
